import { AjaxService, internalMessageBus, EventsManager, Cookies } from "../../externals";
import { delay, getClock, makeTokenRequest } from "../../helpers";
import { WalletRequestService } from "../RequestService";
import { TokenHandler, TokenProcessingGateway, RequestGateway, TokenStream, LogoutSubscription, TokenLoginSubscription, TokenReader, CookiesStorage, RenewErrorHandler, TokenLoginGateway } from "../../common";
import { PlatformJwtManager } from "../../PlatformJwtManager";
export const walletAuthContextFactory = (config) => {
    const tokenReader = new TokenReader(config.siteID, getClock(config.timeControl, config.initialTime));
    const tokenStorage = new CookiesStorage(tokenReader, Cookies);
    const service = new WalletRequestService(config.apiUrl, new AjaxService(), config.domainID, makeTokenRequest);
    const gateway = getGateway(config, service, tokenStorage, tokenReader);
    const platformJwtManager = new PlatformJwtManager(tokenStorage, config.player, tokenReader, gateway);
    return {
        Gateway: gateway,
        PlatformJwtManager: platformJwtManager,
        Subscriptions: getSubscriptions(gateway, tokenReader, service, config)
    };
};
const getGateway = (config, service, storage, tokenReader) => {
    const tokenHandler = new TokenHandler(storage, internalMessageBus);
    const errorHandler = new RenewErrorHandler(config.player, new EventsManager());
    const tokenStream = new TokenStream(service, tokenHandler, tokenReader, errorHandler);
    const tokenProcessingGateway = new TokenProcessingGateway(tokenStream);
    return new RequestGateway(service, tokenProcessingGateway, storage, tokenReader, delay);
};
const getSubscriptions = (gateway, tokenReader, service, config) => [
    new LogoutSubscription(config.player, gateway, tokenReader),
    new TokenLoginSubscription(config.player, new TokenLoginGateway(config.player, gateway, tokenReader, service, legacyWalletTokenLogin))
];
export const legacyWalletTokenLogin = (player, result) => player.legacyWalletTokenLogin(result);
//# sourceMappingURL=WalletAuthContextFactory.js.map